import Vue from "vue";
import { BIconCheckCircle, BIconQuestionCircle, BIconExclamationCircle, BIconXCircle } from "bootstrap-vue";
import UnderstandButton from "../components/ui/Toast/UnderstandButton.vue";

export const IMPERSONATION_ORIGINAL_CLIENT_KEY = "impersonationOriginalClient";

const functions = {
	displayInfo: function (vm, message) {
		vm.$toast.info(vm.$t("commons.display.info") + ": " + message, {
			icon: BIconQuestionCircle
		});
	},
	displaySuccess: function (vm, message) {
		vm.$toast.success(vm.$t("commons.display.success") + ": " + message, {
			icon: BIconCheckCircle
		});
	},
	displayWarning: function (vm, message) {
		this.disablePointerEvents();
		vm.$toast.warning(vm.$t("commons.display.warning") + ": " + message, {
			icon: BIconExclamationCircle,
			closeButton: UnderstandButton,
			onClose: () => this.enablePointerEvents()
		});
	},
	displayError: function (vm, message) {
		this.disablePointerEvents();
		vm.$toast.error(vm.$t("commons.display.error") + ": " + message, {
			icon: BIconXCircle,
			closeButton: UnderstandButton,
			onClose: () => this.enablePointerEvents()
		});
	},
	displayButton: function (email) {
		Vue.swal.fire({
			icon: "warning",
			text: this.$t("messages.sendEmailInfo", [email]),
			showConfirmButton: false,
			timer: 6000
		});
	},
	attentionSwal: function () {
		Vue.swal.fire({
			icon: "warning",
			text: this.$t("messages.waitExcludeContact"),
			showConfirmButton: false,
			timer: 3000
		});
	},
	disablePointerEvents: () => {
		document.getElementById("app").classList.add("noPointerEvents");
		let modalContent = document.getElementsByClassName("modal-content")[0];
		if (modalContent) {
			modalContent.style.pointerEvents = "none";
		}
	},
	enablePointerEvents: () => {
		document.getElementById("app").classList.remove("noPointerEvents");
		let modalContent = document.getElementsByClassName("modal-content")[0];
		if (modalContent) {
			modalContent.style.pointerEvents = "auto";
		}
	},
	formatDateFromBack(inputDate) {
		var date = new Date(inputDate);
		var day = date.getDate();
		var month = date.getMonth() + 1;
		var year = date.getFullYear();
		var formatedDate = (day < 10 ? "0" : "") + day + "/" + (month < 10 ? "0" : "") + month + "/" + year;
		return formatedDate;
	},
	formatDate(date) {
		let d = new Date(date),
			month = "" + (d.getMonth() + 1),
			day = "" + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return [day, month, year].join("/");
	},
	formatFullDate(date) {
		let d = new Date(date),
			month = "" + (d.getMonth() + 1),
			day = "" + d.getDate(),
			year = d.getFullYear(),
			hour = "" + d.getHours(),
			minutes = "" + d.getMinutes(),
			seconds = "" + d.getSeconds();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;
		if (hour.length < 2) hour = "0" + hour;
		if (minutes.length < 2) minutes = "0" + minutes;
		if (seconds.length < 2) seconds = "0" + seconds;
		return [day, month, year].join("/") + " " + [hour, minutes, seconds].join(":");
	},
	formatDateEnterprise(date) {
		let d = new Date(date),
			month = "" + (d.getMonth() + 1),
			day = "" + d.getDate(),
			year = d.getFullYear(),
			hour = "" + d.getHours(),
			minutes = "" + d.getMinutes();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;
		if (hour.length < 2) hour = "0" + hour;
		if (minutes.length < 2) minutes = "0" + minutes;
		return [day, month, year].join("/") + " às " + [hour, minutes].join(":");
	},
	formatDateWorkflowDetails(date) {
		let d = new Date(date),
			month = "" + (d.getMonth() + 1),
			day = "" + d.getDate(),
			year = d.getFullYear(),
			hour = "" + d.getHours(),
			minutes = "" + d.getMinutes();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;
		if (hour.length < 2) hour = "0" + hour;
		if (minutes.length < 2) minutes = "0" + minutes;
		return [hour, minutes].join(":") + " em " + [day, month, year].join("/");
	},
	formatImpersonatorDisplayName: function (vm, userName, impersonatorName) {
		return impersonatorName
			? `${impersonatorName} (${vm.$t("modals.workflowHistoryDetails.actingAs")} ${userName})`
			: userName;
	},
	formatArrayToText(array, useQuotation) {
		if (!Array.isArray(array) || array.length == 0) return "";

		if (array.length == 1) {
			return useQuotation ? `"${array[0]}"` : `${array[0]}`;
		} else if (array.length == 2) {
			return useQuotation ? `"${array[0]}" e "${array[1]}"` : `${array[0]} e ${array[1]}`;
		}

		var formattedArray = array.map((item) => (useQuotation ? `"${item}"` : `${item}`));
		return `${formattedArray.slice(0, -1).join(", ")} e ${formattedArray.slice(-1)}`;
	},

	validateDate(date) {
		var length = date.length;
		var j = 0;
		var dt = { 0: "", 1: "", 2: "" };
		var monthDays = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

		for (var i = 0; i < length; i++) {
			var c = date[i];
			if (c !== "/") dt[j] += c;
			else j++;
		}
		var d = +dt[0];
		var m = +dt[1];
		var y = +dt[2];

		// atualiza dias do ano bisexto
		monthDays[2] += +(y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0));
		if (date == "") {
			return true;
		}
		if (m < 1 || m > 12 || d < 1) {
			return false;
		} else if (d > monthDays[m]) {
			return false;
		} else if (y < 1900) {
			return false;
		}
		return true;
	},
	validateCpfCnpj(val) {
		if (!val) return false;

		if (val.length == 14) {
			return this.validateCpf(val);
		} else if (val.length == 18) {
			return this.validateCnpj(val);
		}

		return false;
	},
	validateNIF(nif) {
		return /^[a-zA-Z0-9]{8,50}$/.test(nif);
	},
	validateCpf(val) {
		if (!val) return false;

		let cpf = val.trim();

		cpf = cpf.replace(/\./g, "");
		cpf = cpf.replace("-", "");
		cpf = cpf.split("");

		let v1 = 0;
		let v2 = 0;
		let aux = false;

		for (let i = 1; cpf.length > i; i++) {
			if (cpf[i - 1] != cpf[i]) {
				aux = true;
			}
		}

		if (aux == false) {
			return false;
		}

		for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
			v1 += cpf[i] * p;
		}

		v1 = (v1 * 10) % 11;

		if (v1 == 10) {
			v1 = 0;
		}

		if (v1 != cpf[9]) {
			return false;
		}

		for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
			v2 += cpf[i] * p;
		}

		v2 = (v2 * 10) % 11;

		if (v2 == 10) {
			v2 = 0;
		}

		if (v2 != cpf[10]) {
			return false;
		} else {
			return true;
		}
	},
	validateCnpj(val) {
		if (!val) return false;

		let cnpj = val.trim();

		cnpj = cnpj.replace(/\./g, "");
		cnpj = cnpj.replace("-", "");
		cnpj = cnpj.replace("/", "");
		cnpj = cnpj.toUpperCase();
		cnpj = cnpj.split("");

		if (cnpj.length != 14) {
			return false;
    	}

		for (let i = 0; i < 12; i++) {
			if (!/[A-Z0-9]/.test(cnpj[i])) {
            	return false;
        	}
    	}

		for (let i = 12; i < 14; i++) {
			if (!/[0-9]/.test(cnpj[i])) {
        		return false;
        	}
    	}

		let v1 = 0;
		let v2 = 0;
		let aux = false;

		for (let i = 1; cnpj.length > i; i++) {
			if (cnpj[i - 1] != cnpj[i]) {
				aux = true;
			}
		}

		if (aux == false) {
			return false;
		}

		for (let i = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i; i++, p1--, p2--) {
			if (p1 >= 2) {
				v1 += (cnpj[i].charCodeAt(0) - 48) * p1;
			} else {
				v1 += (cnpj[i].charCodeAt(0) - 48) * p2;
			}
		}

		v1 = v1 % 11;

		if (v1 < 2) {
			v1 = 0;
		} else {
			v1 = 11 - v1;
		}

		if (v1 != cnpj[12]) {
			return false;
		}

		for (let i = 0, p1 = 6, p2 = 14; cnpj.length - 1 > i; i++, p1--, p2--) {
			if (p1 >= 2) {
				v2 += (cnpj[i].charCodeAt(0) - 48) * p1;
			} else {
				v2 += (cnpj[i].charCodeAt(0) - 48) * p2;
			}
		}

		v2 = v2 % 11;

		if (v2 < 2) {
			v2 = 0;
		} else {
			v2 = 11 - v2;
		}

		if (v2 != cnpj[13]) {
			return false;
		} else {
			return true;
		}
	},
	validateMinMaxLenght(min, max) {
		const minInt = parseInt(min);
		const maxInt = parseInt(max);
		if (minInt < 0 || minInt > 4000 || maxInt < 0 || maxInt > 4000) {
			return false;
		} else if (minInt > maxInt) {
			return false;
		}
		return true;
	},
	validateMinMax(value, min, max) {
		let textLimitMin = parseInt(min) || 0;
		let textLimitMax = parseInt(max) || 4000;
		if (value) {
			if (value.length < textLimitMin || value.length > textLimitMax) return false;
		}
		return true;
	},
	validateDecimal(value) {
		if (!value) return false;

		var formatedDecimal = value + "";
		formatedDecimal = parseInt(value.replace(/[\D]+/g, ""));
		formatedDecimal = value + "";
		formatedDecimal = value.replace(/([0-9]{2})$/g, ",$1");

		if (formatedDecimal.length > 6) {
			formatedDecimal = value.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
			return formatedDecimal;
		} else {
			return false;
		}
	},
	validateCurrency(value) {
		if (!value) return false;

		var formatedCurrency = value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

		return formatedCurrency;
	},
	validateFileProperties: function (data, thisPropertie) {
		if (!data || data.size === 0) {
			this.displayError(thisPropertie, thisPropertie.$t("messages.fileError.cantBeEmpty", [data.name]));
			return false;
		}

		const fileLengthInMb = data.size / (1024 * 1024);

		if (fileLengthInMb >= Vue.prototype.$FileLengthInMB.MAX_FILE_LENGTH) {
			this.displayError(thisPropertie, thisPropertie.$t("messages.fileError.sizeExceeded", [data.name]));
			return false;
		}
		const fileName = data.name.toLowerCase();
		const extension = fileName.substring(fileName.lastIndexOf("."));

		const prohibitedExtensions = [
			".zip",
			".rar",
			".7z",
			".tar",
			".gz",
			".bz2",
			".xz",
			".cab",
			".z",
			".lz",
			".lzma",
			".exe",
			".bat",
			".cmd",
			".ps1",
			".vbs",
			".js",
			".jse",
			".wsf",
			".wsh",
			".msc",
			".msi",
			".msp",
			".com",
			".scr",
			".hta",
			".cpl",
			".jar",
			".vb",
			".vbe",
			".aspx",
			".asp",
			".php",
			".py",
			".pl",
			".rb",
			".sh",
			".go",
			".msg",
			".eml",
			".dll",
			".ocx",
			".sys",
			".sql",
			".mdb",
			".accdb",
			".iso",
			".bin",
			".cgi",
			".inf",
			".html",
			".htm",
			".css",
			".xml",
			".pif",
			".ade",
			".adp",
			".bas",
			".chm",
			".class",
			".csh",
			".gadget",
			".lnk",
			".msh",
			".msh1",
			".msh2",
			".mshxml",
			".msh1xml",
			".msh2xml",
			".scf",
			".url",
			".ws",
			".drv",
			".efi",
			".tmp",
			".apk",
			".war",
			".ear",
			".xpi",
			".nupkg",
			".vsix",
			".reg",
			".docm",
			".xlsm",
			".pptm",
			".jsp",
			".lnk",
			".scr",
			".url",
			".htaccess",
			".config",
			".ini"
		];

		if (prohibitedExtensions.includes(extension)) {
			this.displayError(thisPropertie, thisPropertie.$t("messages.fileError.prohibitedExtension", [data.name]));
			return false;
		}

		const fileNameParts = fileName.split(".");
		if (fileNameParts.length > 2) {
			for (let i = 1; i < fileNameParts.length; i++) {
				const currentExt = "." + fileNameParts[i];
				if (prohibitedExtensions.includes(currentExt)) {
					this.displayError(thisPropertie, thisPropertie.$t("messages.fileError.prohibitedExtension", [data.name]));
					return false;
				}
			}
		}

		return true;
	},
	isSpecialCharacter(value) {
		const isSpecialCaracterRegex = /[!@#$%^=&*()_+{}\[\]:;<>,.?~\\/-]/;
		if (isSpecialCaracterRegex.test(value)) return true;
		return false;
	},
	isMaskNumberCharacter(value) {
		// vanilla-masker permite apenas 9 para representar numeros
		const isNumberRegex = /^[9]+$/;
		if (isNumberRegex.test(value)) return true;

		return false;
	},
	isMaskLetterCharacter(value) {
		// vanilla-masker permite apenas A e S para representar letras
		const isLetterRegex = /^[AS]+$/;
		if (isLetterRegex.test(value)) return true;

		return false;
	},
	isNumberCharacter(value) {
		const isNumberRegex = /^[0-9]+$/;
		if (isNumberRegex.test(value)) return true;

		return false;
	},
	isLetterCharacter(value) {
		const isLetterRegex = /^[aA-zZ]+$/;
		if (isLetterRegex.test(value)) return true;

		return false;
	},
	cnpjCpfFormatFromBack(cnpjCpf) {
		cnpjCpf = cnpjCpf.toString();
		const cnpjCpfLength = cnpjCpf.length;

		if (cnpjCpfLength === 11) {
			// Formatar CPF
			cnpjCpf = cnpjCpf.padStart(11, "0");
			return `${cnpjCpf.slice(0, 3)}.${cnpjCpf.slice(3, 6)}.${cnpjCpf.slice(6, 9)}-${cnpjCpf.slice(9)}`;
		} else if (cnpjCpfLength === 14) {
			// Formatar CNPJ
			cnpjCpf = cnpjCpf.padStart(14, "0");
			return `${cnpjCpf.slice(0, 2)}.${cnpjCpf.slice(2, 5)}.${cnpjCpf.slice(5, 8)}/${cnpjCpf.slice(
				8,
				12
			)}-${cnpjCpf.slice(12)}`;
		}
	},
	formatCnpjCpfToBack(cnpjCpf) {
    	if (!cnpjCpf) return cnpjCpf;
    	cnpjCpf = cnpjCpf.replace(/[^A-Za-z0-9]/g, "");
    	return cnpjCpf.toUpperCase();
	},
	formatDateToBack: function (date) {
		if (!date) return null;
		if (date.split("/").length == 1) {
			return date;
		}
		let splittedDate = date.split("/");
		let formattedDate = splittedDate[2] + "-" + splittedDate[1] + "-" + splittedDate[0] + "T00:00:00";
		return formattedDate;
	},
	isObjectJSON(value) {
		const objectRegex = /^\{.*\}$/;
		if (objectRegex.test(value)) return true;
		return false;
	},
	clearLocalStorage() {
		localStorage.removeItem("authToken");
		localStorage.removeItem("actualUser");
		localStorage.removeItem("enableUpperLetter");
		sessionStorage.removeItem(IMPERSONATION_ORIGINAL_CLIENT_KEY);
		this.clearFiltersLocalStorage();
	},
	clearFiltersLocalStorage() {
		localStorage.removeItem("enterpriseFilter");
		localStorage.removeItem("supplierListFilter");
		localStorage.removeItem("userListFilter");
		localStorage.removeItem("clientId");
		localStorage.removeItem("requirementListFilter");
		localStorage.removeItem("materialListFilter");
		localStorage.removeItem("translationListFilter");
	},
	answerTypeIsNotAlternative(responseType) {
		const responseTypesWithoutAlternatives = [
			Vue.prototype.$ResponseType.FreeText,
			Vue.prototype.$ResponseType.Email,
			Vue.prototype.$ResponseType.Monetary
		];

		return responseTypesWithoutAlternatives.includes(responseType);
	},
	isNullOrEmpty(value) {
		if (value === null || value === undefined || (typeof value === "string" && value.trim() === "")) return true;

		return false;
	},
	canAntecipateValidity({ requirement, statusDescription, userActorList, updatePermission }) {
		if (updatePermission) return true;

		const isNotExpiredOrValidToAntecipate =
			!requirement?.isExpired ||
			(requirement?.isExpired &&
				!requirement.validityDate &&
				statusDescription != this.$t("commons.homologationSituation.expired"));

		if (!updatePermission && requirement.allowAntecipateValidity) {
			return (
				requirement.idRequirementActors?.some((actorId) => userActorList.includes(actorId)) &&
				isNotExpiredOrValidToAntecipate
			);
		}

		return requirement.allowAntecipateValidity && isNotExpiredOrValidToAntecipate;
	},
	readUpperCaseStorageConfig() {
		return localStorage.getItem("enableUpperLetter") === "true" ? true : false;
	},
	filterFamiliesTree(tree, selectedFamilies) {
		const hasSelectedDescendant = (node) => {
			if (selectedFamilies.includes(node.idFamily)) return true;
			if (!node.children) return false;
			return node.children.some(hasSelectedDescendant);
		};
		const filterNodes = (nodes) =>
			nodes
				.map((node) => {
					const hasChildren = Array.isArray(node.children) && node.children.length > 0;
					// Se algum descendente está selecionado, mantém toda a estrutura abaixo (sem filtrar os filhos)
					if (hasSelectedDescendant(node)) {
						return {
							...node,
							children: node.children ? [...node.children] : []
						};
					}
					// Se o nó está ativo, mantém normalmente (mas filtra os filhos)
					if (node.isActive) {
						return {
							...node,
							children: hasChildren ? filterNodes(node.children) : []
						};
					}
					// Caso contrário, remove o nó
					return null;
				})
				.filter(Boolean);
		return filterNodes(tree);
	},
	requirementsRehomologation() {
		const selectedRequirementsStr = sessionStorage.getItem("selectedRequirementsRehomologation");
		try {
			const selectedRequirements = JSON.parse(selectedRequirementsStr);
			return selectedRequirements || [];
		} catch (error) {
			console.error("Erro ao recuperar requisitos selecionados:", error);
		}
	},
	defaultFormatter(value, options = {}) {
		if (!value) return "";

		let formattedValue = "";

		const allowedChar = Array.isArray(options.allowedChar) ? options.allowedChar : [];
		const usedTextCasing =
			options.textCasing == Vue.prototype.$LetterCaseEnum.Upper ||
			options.textCasing == Vue.prototype.$LetterCaseEnum.Lower;
		const usedFormatter = typeof options.formatter === "function";
		const usedMask = !!options.customMask;

		let allowedCharUsed = false;

		const hasMaskFormatter = () => {
			return allowedCharUsed || usedTextCasing || usedFormatter || usedMask;
		};

		if (allowedChar.length > 0) {
			let regexString = "";
			if (allowedChar.includes("letter")) regexString += "a-zA-Z\\s";
			if (allowedChar.includes("number")) regexString += "0-9";
			if (allowedChar.includes("specialChar")) regexString += "\\W_";

			const regex = new RegExp(`[${regexString}]`, "g");
			formattedValue = value.match(regex)?.join("") || "";
			allowedCharUsed = true;
		} else {
			formattedValue = value;
		}

		if (usedTextCasing) {
			if (options.textCasing === Vue.prototype.$LetterCaseEnum.Upper) {
				formattedValue = formattedValue.toUpperCase();
			} else if (options.textCasing === Vue.prototype.$LetterCaseEnum.Lower) {
				formattedValue = formattedValue.toLowerCase();
			}
		}

		if (usedFormatter) {
			formattedValue = options.formatter(formattedValue);
		} else if (usedMask && window.VMasker) {
			formattedValue = window.VMasker.toPattern(formattedValue, options.customMask);
		}

		if (options.toUpperCase && hasMaskFormatter()) {
			formattedValue = formattedValue.toUpperCase();
		}

		return formattedValue;
	},
	// Métodos para gerenciamento de cursor
	getCursorPositionAndValue(element, event, fallbackValue) {
		let cursorPosition = 0;
		let currentValue = "";

		try {
			if (element) {
				cursorPosition = element.selectionStart || 0;
				currentValue = element.value || "";
			} else if (event && event.target) {
				cursorPosition = event.target.selectionStart || 0;
				currentValue = event.target.value || "";
			}
		} catch (e) {
			cursorPosition = 0;
			currentValue = fallbackValue || "";
		}
		return { cursorPosition, currentValue };
	},
	restoreCursorPosition(element, cursorPosition, callback) {
		Vue.nextTick(() => {
			try {
				if (element && element.setSelectionRange && typeof element.setSelectionRange === "function") {
					element.setSelectionRange(cursorPosition, cursorPosition);
				}
			} catch (e) {
				// Ignora erros de seleção
			}
			if (callback && typeof callback === "function") {
				callback();
			}
		});
	},
	applyUpperCaseWithCursorPreservation(currentValue, cursorPosition, element, updateCallback) {
		const upperValue = currentValue.toUpperCase();

		if (upperValue !== currentValue) {
			if (updateCallback && typeof updateCallback === "function") {
				updateCallback(upperValue);
			}
			this.restoreCursorPosition(element, cursorPosition);
		}
	},
	normalizeLanguage(lang) {
		// Aceita pt-br, pt_BR, pt-BR, PT-br, etc.
		if (!lang) return "pt-BR";
		const normalized = lang.replace(/_/g, "-").toLowerCase();
		return normalized === "pt-br" ? "pt-BR" : normalized;
	},
	setLanguage(vm, language) {
		const normalizedLanguage = this.normalizeLanguage(language) || "pt-BR";
		localStorage.setItem("k4-language", normalizedLanguage);
		if (vm && vm.$i18n) {
			vm.$i18n.locale = normalizedLanguage;
		}
		return;
	},
	configureLanguage(vm, language, options = {}) {
		const { updateRoute = true, routeName } = options;
		this.setLanguage(vm, language);

		if (updateRoute && language && vm?.$route?.params?.language !== language) {
			vm.$router.replace({ name: routeName, params: { language } });
		}
		return;
	}
};
Vue.use({
	install(Vue) {
		Vue.prototype.$functions = functions;
	}
});
